import { render, staticRenderFns } from "./FavoriteCatalogItem.vue?vue&type=template&id=03d9c537&"
import script from "./FavoriteCatalogItem.vue?vue&type=script&lang=js&"
export * from "./FavoriteCatalogItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports